module.exports = __webpack_public_path__ + "static/img/handIdCardicon@2x.465d3015.png";